import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ColorService {

  constructor() { }

  // this is used to convert a string (name) to one of the colors in the array
  colors = ['#0051e1', '#146755', '#808081'];

  getColor(name: string) {
    const index = name.length % this.colors.length;
    return this.colors[index];
  }
}
